

import { mapGetters } from 'vuex'
import StoreDetail from '@/components/StoreDetail'
import GoogleReviews from '@/components/GoogleReviews'
import { checkDealSchedule } from '@/../common/utils/dealSchedule.js'

export default {
  name: 'HomePage',
  components: {
    StoreDetail,
    GoogleReviews
  },
  head () {
    const head = {
      title: this.$getPageTitle('Home')
    }
    if (this.storeSchema) {
      head.script = [{
        hid: 'store-schema',
        type: 'application/ld+json',
        json: this.storeSchema
      }]
    }
    return head
  },
  computed: {
    ...mapGetters(['products', 'currentStore', 'storeInfo', 'currentMoment']),
    productList () {
      if (this.products.deal) {
        return this.products.deal.items.filter(item => checkDealSchedule(item, this.storeInfo ? this.storeInfo.schedule : null, null, this.currentMoment))
      }
      return []
    },
    storeSchema () {
      const store = this.currentStore
      const info = this.storeInfo
      if (!store || !info) {
        return null
      }

      const name = store.name && store.name.toLowerCase().includes('tops pizza')
        ? store.name
        : `Tops Pizza ${store.name}`

      const postcode = store.postcode && typeof store.postcode === 'object'
        ? store.postcode.postcode
        : store.postcode

      const schema = {
        '@context': 'https://schema.org',
        '@type': 'Restaurant',
        name,
        servesCuisine: 'Pizza',
        url: 'https://topspizza.co.uk',
        address: {
          '@type': 'PostalAddress',
          streetAddress: store.address || undefined,
          addressLocality: store.city || undefined,
          postalCode: postcode || undefined,
          addressCountry: 'GB'
        }
      }

      const telephone = info.telephone || store.phone_number
      if (telephone) {
        schema.telephone = telephone
      }

      if (info.lat && info.lon) {
        schema.geo = {
          '@type': 'GeoCoordinates',
          latitude: parseFloat(info.lat),
          longitude: parseFloat(info.lon)
        }
      }

      const hours = this.buildOpeningHours(info.schedule)
      if (hours.length) {
        schema.openingHoursSpecification = hours
      }

      return schema
    }
  },
  methods: {
    buildOpeningHours (schedule) {
      if (!schedule) {
        return []
      }
      const dayMap = {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
      }
      const result = []
      Object.keys(dayMap).forEach((day) => {
        const value = schedule[day]
        if (value && typeof value === 'string' && value.includes(',')) {
          const parts = value.split(',')
          const opens = parts[0] ? parts[0].trim() : null
          const closes = parts[1] ? parts[1].trim() : null
          if (opens && closes) {
            result.push({
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: dayMap[day],
              opens,
              closes
            })
          }
        }
      })
      return result
    }
  }
}
